import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive, watch, ref } from 'vue';
import { useFormChanged } from '@/hooks';
import { modal } from '@/share/components';
import { XEditorLayout } from '@/components';
import dayjs from 'dayjs';
import { omit } from '@/utils';

import { useComponentModalInstance } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/share/hooks/common/index.js';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'proj-kpi-editor-form',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const modalInst = useComponentModalInstance();
    const props = __props;
    const formData = reactive({
      code: '',
      name: '',
      budgetTotal: 0,
      // 预算总额
      budgetUnit: '',
      // 填报单位
      annualTarget: '',
      // 年度目标
      assetType: 0,
      // 是否新增加资产
      establish: dayjs(),
      // 设立年度
      planYear: dayjs(),
      // 计划年度
      inputName: '',
      // 填报人
      contactPer: '',
      // 联系人
      contactTel: '' // 联系电话
    });
    const oldFormData = reactive({});
    const {
      isChanged,
      reset
    } = useFormChanged(oldFormData, formData);
    const rules = reactive({
      name: [{
        trigger: 'blur',
        required: true,
        message: '指标分类名称不能为空'
      }]
    });
    const {
      loading,
      error,
      runAsync: getProjKpiDetail
    } = fetchApi('kpi.projKpi.getDetail');
    const {
      loading: saveLoading,
      runAsync: saveProjKpi
    } = fetchApi('kpi.projKpi.save');
    const loadDetail = async id => {
      if (!id) return;
      const {
        error,
        ...res
      } = await getProjKpiDetail({
        id
      });
      if (error) return;
      const {
        establish,
        planYear
      } = res;
      res.establish = dayjs().set('year', establish);
      res.planYear = dayjs().set('year', planYear);
      Object.assign(oldFormData, res);
      Object.assign(formData, res);
      reset();
    };
    watch([isChanged, saveLoading], val => {
      const [b1, b2] = val;
      modalInst.setConfirmButton({
        disabled: !b1,
        loading: b2
      });
    });
    watch(() => props.id, val => {
      loadDetail(val);
    }, {
      immediate: true
    });
    const save = async () => {
      const valid = await formRef.value.validate();
      if (!valid) return false;
      const {
        establish,
        planYear
      } = formData;
      const postData = {
        ...formData,
        ...omit({
          id: props.id,
          establish: establish.year(),
          planYear: planYear.year()
        })
      };
      const {
        error
      } = await saveProjKpi(postData);
      if (error) return false;
      modal.notification.success(`保存指标基本信息[${formData.name}]成功`, '保存指标基本信息');
      return true;
    };
    const onOk = async () => {
      return await save();
    };
    const onCancel = async () => {};
    __expose({
      confirmListener: onOk,
      cancelListener: onCancel,
      save
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_textarea = _resolveComponent("a-textarea");
      return _openBlock(), _createBlock(_unref(XEditorLayout), {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: rules,
        loading: _unref(loading),
        error: _unref(error)
      }, {
        default: _withCtx(() => [_createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目编码",
              name: "code",
              disabled: props.id
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: formData.code,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.code = $event)
              }, null, 8, ["value"])]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "项目名称",
              name: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: formData.name,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.name = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "设立年度",
              name: "establish"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                picker: "year",
                value: formData.establish,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.establish = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "计划年度",
              name: "planYear"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                picker: "year",
                value: formData.planYear,
                "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.planYear = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "是否新增资产",
              name: "assetType"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                value: formData.assetType,
                "onUpdate:value": _cache[4] || (_cache[4] = $event => formData.assetType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio, {
                  value: 1
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("是", -1)]))]),
                  _: 1
                }), _createVNode(_component_a_radio, {
                  value: 0
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("否", -1)]))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "年度目标",
          name: "annualTarget"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: formData.annualTarget,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => formData.annualTarget = $event),
            "auto-size": {
              minRows: 2,
              maxRows: 5
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "填报人",
              name: "inputName"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: formData.inputName,
                "onUpdate:value": _cache[6] || (_cache[6] = $event => formData.inputName = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "联系人",
              name: "contactPer"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: formData.contactPer,
                "onUpdate:value": _cache[7] || (_cache[7] = $event => formData.contactPer = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "联系电话",
              name: "contactTel"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: formData.contactTel,
                "onUpdate:value": _cache[8] || (_cache[8] = $event => formData.contactTel = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "loading", "error"]);
    };
  }
};